import { ClubCurrencyIconV2 } from '@wwe-portal/ui/components/icons';
import { Dialog, CommonDialogLayout } from '@wwe-portal/ui/components/dialog';

export interface OutStockClubCoinDialogProps {
  onClose?: () => void;
  onChange?: () => void;
  open?: boolean;
  data?: {
    actionElement?: React.ReactNode;
  };
}
export function OutStockClubCoinDialog({
  onClose,
  open = true,
  data,
}: Readonly<OutStockClubCoinDialogProps>) {
  return (
    <Dialog
      onOpenChange={(isOpen: boolean) => {
        if (!isOpen) onClose?.();
      }}
      open={open}
    >
      <CommonDialogLayout
        actionElement={data?.actionElement}
        closable
        dataId="OutStockClubCoinDialog"
        descriptionElement={
          <div className="mt-5">
            <p className="text-textColor8 text-xl font-semibold leading-6">
              Not Enough Club Coins
            </p>
            <span className="text-text400 text-sm font-medium leading-[26px]">
              How to earn more Club Coins?
            </span>
          </div>
        }
        hasBackground
        imageElement={
          <div className="border-text700 flex size-[96px] items-center justify-center rounded-full border-4 border-solid">
            <ClubCurrencyIconV2 className="size-[60px]" />
          </div>
        }
        layoutClass="px-6"
        onClose={onClose}
        titleElement={undefined}
      />
    </Dialog>
  );
}

export default OutStockClubCoinDialog;
